import { Row, Col, Form, Divider, DatePicker, Button, Space, Input, Radio, UploadProps, UploadFile } from "antd";
import "./style/index.scss";
import dayjs from "dayjs";
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { useEffect, useState } from "react";
import { setModalCadastrarLancamentoConsignatario } from "../../../../redux/slices/lancamentoConsignatario/lancamentoConsignatarioSlice";
import { CheckOutlined, CloseOutlined, InboxOutlined } from "@ant-design/icons";
import { atualizarLancamentoConsignatario, cadastrarLancamentoConsignatario } from "../../../../services/lancamentoConsignatarioService";
import { realParaNumber } from "../../../../util/dinheiroBRAuxiliar";
import { NumericFormat } from "react-number-format";
import Dragger from "antd/es/upload/Dragger";
import { LancamentoConsignatarioModel } from "../../../../models/lancamentoConsignatario/lancamentoConsignatarioModel";
import { listarAnexosConsignatario } from "../../../../services/prestacaoContaService";
import { toastError, toastWarning } from "../../../../util/toast";
import { sendImageToAmazonS3 } from "../../../../util/functions/sendImageToAmazonS3";

interface FormValues {
  nomeConsignatario: string;
  dataTransacao: Date;
  valorTransacao: number;
  entradaSaida: string;
  historico: string;
  arquivo: UploadFile[];
  caminhoArquivo: string;
  extensaoArquivo: string;
  nomeArquivo: string;
}

const PagamentoAvulsoConsignatario = () => {
  //estados globais
  const lancamentoConsignatarioState = useAppSelector((state) => state.lancamentoConsignatario);
  const prestacaoContaState = useAppSelector((state) => state.prestacaoConta);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<FormValues>();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const editar = Object.values(lancamentoConsignatarioState.entity).length !== 0;

  const options = [
    { label: "Crédito", value: "E" },
    { label: "Débito", value: "S" },
  ];

  useEffect(() => {
    var arq =
      lancamentoConsignatarioState.entity.nomeArquivo !== null
        ? [
            {
              uid: "-1",
              name: lancamentoConsignatarioState.entity.nomeArquivo !== null ? lancamentoConsignatarioState.entity.nomeArquivo : "",
              status: "done" as any,
              type: lancamentoConsignatarioState.entity.extensaoArquivo !== null ? lancamentoConsignatarioState.entity.extensaoArquivo : "",
              url: lancamentoConsignatarioState.entity.caminhoArquivo !== null ? lancamentoConsignatarioState.entity.caminhoArquivo : "",
            },
          ]
        : [];
    if (editar) {
      form.setFieldsValue({
        dataTransacao: dayjs(),
        nomeConsignatario: prestacaoContaState.entity.apelido,
        historico: lancamentoConsignatarioState.entity.historico,
        entradaSaida: lancamentoConsignatarioState.entity.entradaSaida,
        valorTransacao: Math.abs(lancamentoConsignatarioState.entity.valorTransacao),
        arquivo: arq,
      });

      setFileList(arq);
    } else {
      form.setFieldsValue({
        dataTransacao: dayjs(),
        arquivo: [],
        nomeConsignatario: prestacaoContaState.entity.apelido,
      });
      setFileList([]);
    }

    dispatch(listarAnexosConsignatario({ idTipoArquivoAnexo: 10, idConsignatario: lancamentoConsignatarioState.entity.idConsignatario }));
  }, [lancamentoConsignatarioState.entity, prestacaoContaState.entity]);

  const isDateDisabled = (current: any) => {
    const today = moment();

    today.set("hour", 0);
    today.set("minute", 0);
    today.set("second", 0);
    today.set("millisecond", 0);

    return current && current.isAfter(today, "day");
  };

  const submit = async (values: any) => {
    let url = null;

    try {
      if (values.arquivo.length !== 0) {
        url = await sendImageToAmazonS3(values.arquivo[0]);
      }
    } catch (e) {
      toastError("Ocorreu um erro ao fazer o upload do arquivo");
      return;
    }

    var data: LancamentoConsignatarioModel = {
      ...values,
      data: values.dataTransacao,
      caminhoArquivo: url,
      nomeArquivo: values.arquivo.length !== 0 ? values.arquivo[0].name : "",
      extensaoArquivo: values.arquivo.length !== 0 ? values.arquivo[0].type : "",
      idConsignatario: prestacaoContaState.entity.idConsignatario,
    };
    if (editar) {
      dispatch(
        atualizarLancamentoConsignatario({
          value: { ...data, id: lancamentoConsignatarioState.entity.id },
          buscaLancamento: lancamentoConsignatarioState.busca,
          buscaPrestacao: prestacaoContaState.busca,
        })
      );
    } else {
      dispatch(cadastrarLancamentoConsignatario({ value: { ...data }, buscaLancamento: lancamentoConsignatarioState.busca, buscaPrestacao: prestacaoContaState.busca }));
    }
  };

  const toBase64 = (img: any, callback: any) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const uprops: UploadProps = {
    multiple: false,
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isPNG = file.type === "image/png" || file.type === "application/pdf" || file.type === "image/jpeg";
      if (!isPNG) {
        toastWarning("Selecione um arquivo com extensão PDF, PNG ou JPG.");
      } else {
        setFileList([file]);
      }
      return false;
    },
    onChange: ({ fileList: newFileList }) => {
      form.setFieldsValue({ arquivo: newFileList });

      // if (newFileList[0] !== undefined) {

      //   toBase64(newFileList[0].originFileObj, (imageUrlResponse: any) => {
      //     form.setFieldsValue({ arquivo: [{ type: newFileList[0].type, url: imageUrlResponse, name: newFileList[0].name }] });
      //   });
      // }
    },
    fileList,
  };

  const voltar = () => {
    dispatch(setModalCadastrarLancamentoConsignatario(false));
  };

  return (
    <Form layout="vertical" form={form} onFinish={submit}>
      <Row gutter={12}>
        <Col className="colInformacoes" span={12}>
          <Form.Item label="Consignatário" name="nomeConsignatario">
            <Input type="text" disabled />
          </Form.Item>
        </Col>
        <Col className="colInformacoes" span={5}>
          <Form.Item label="Tipo de lançamento" name="entradaSaida" initialValue={options[0].value}>
            <Radio.Group options={options} optionType="button" buttonStyle="solid" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col className="colInformacoes" span={6}>
          <Form.Item
            label="Data da transação"
            name="dataTransacao"
            rules={[
              {
                required: true,
                message: "Digite uma data",
              },
            ]}
          >
            <DatePicker format="DD/MM/YYYY" allowClear={false} disabledDate={isDateDisabled} />
          </Form.Item>
        </Col>
        <Col className="colInformacoes" span={6}>
          <Form.Item
            label="Valor da transação"
            name="valorTransacao"
            rules={[
              {
                required: true,
                message: "Digite o valor da transação",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              onChange={() => {
                form.setFieldValue("valorTransacao", realParaNumber(form.getFieldValue("valorTransacao")));
              }}
            />
          </Form.Item>
        </Col>
        <Col className="colInformacoes" span={12}>
          <Form.Item label="Histórico" name="historico">
            <Input type="text" className="input-text-historico" />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form.Item label="Anexo de comprovante (*.pdf, *.jpg, *.png)" name="arquivo">
            <Dragger {...uprops}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">Clique ou arraste o arquivo para esta área</p>
            </Dragger>
          </Form.Item>
        </Col>
      </Row>
      <Divider></Divider>
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />} disabled={lancamentoConsignatarioState.loading}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary" disabled={lancamentoConsignatarioState.loading}>
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default PagamentoAvulsoConsignatario;
